<h2 class="text-center font-weight-extrabold">
  {{
    (role == Role.IssuerRep ? 'registerIssuer.issuerRepresentative' : 'signUp.corporateInvestor')
      | translate
  }}
</h2>
<div class="text-center mb-4">{{ 'signUp.representativeDesc' | translate }}</div>
<form (ngSubmit)="submit()" [formGroup]="form" [class.show-form-error]="showFormError">
  <div class="mb-3">
    @if (!isLoading) {
      <div class="input-field">
        <div
          class="profile-upload"
          agmoUploader
          [accept]="accept"
          (selectFiles)="selectFile($event)"
        >
          @if (!profileImage) {
            <div class="profile-image pitchin-icon-profile"></div>
          }
          @if (profileImage) {
            <img class="profile-image" alt="pitchIN User" [src]="profileImage" />
          }
          <div class="pitchin-icon pitchin-icon-add"></div>
        </div>
      </div>
    }
    @if (!profileImage) {
      <div class="text-primary text-center pt-3">
        {{ 'common.dragAndDropImage' | translate }}
      </div>
    }
    @if (profileImage && !isLoading) {
      <div class="text-primary text-center pt-3">
        {{ 'common.lookingGood' | translate }}
      </div>
    }
    @if (isLoading) {
      <agmo-loading></agmo-loading>
    }
  </div>
  <div class="mb-4 mt-4">
    <div class="input-label">{{ 'signUp.identificationType' | translate }}</div>
    <div class="input-field">
      <mat-select
        [placeholder]="'common.selectPlaceholder' | translate"
        class="form-control"
        formControlName="userIdentityNoType"
        (selectionChange)="changeIdentificationType(form)"
      >
        @for (type of IdentificationType | enumToArray; track type) {
          <mat-option [value]="type.key">
            {{ 'signUp.' + type.value | translate }}
          </mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div class="mb-4">
    <div class="input-label">
      {{ 'signUp.representativeNameAsPer' | translate }}
      {{ 'signUp.' + IdentificationType[form.value.userIdentityNoType] | translate }}
    </div>
    <input
      type="text"
      class="form-control"
      placeholder="{{ 'signUp.fullNamePlaceholder' | translate }}"
      formControlName="fullName"
    />
  </div>
  <div class="mb-3">
    <div class="input-label">
      {{ 'signUp.' + IdentificationType[form.value.userIdentityNoType] | translate }}
      {{ 'signUp.number' | translate }}
    </div>
    <div class="input-field">
      @if (form.value.userIdentityNoType != IdentificationType.Passport) {
        <input
          class="form-control"
          placeholder="{{ 'signUp.icNumberPlaceholder' | translate }}"
          formControlName="identityNo"
          [mask]="icMaskFormat"
          type="text"
        />
      }
      @if (form.value.userIdentityNoType == IdentificationType.Passport) {
        <input
          class="form-control"
          placeholder="{{ 'signUp.passportPlaceholder' | translate }}"
          formControlName="identityNo"
          type="text"
          alphanumeric
        />
      }
      @if (
        showFormError &&
        form.controls.identityNo.errors &&
        (form.controls.identityNo.errors.pattern || form.controls.identityNo.errors.mask)
      ) {
        <div class="error">
          {{ 'signUp.' + IdentificationType[form.value.userIdentityNoType] | translate }}
          {{ 'signUp.number' | translate }}
          {{ 'signUp.incorrectFormat' | translate }}
        </div>
      }
    </div>
  </div>
  <div class="other-issuer-panel">
    <div class="title mb-3">
      {{
        (role == Role.IssuerRep
          ? 'registerIssuer.otherIssuerRepresentative'
          : 'company.corporateRepresentative'
        ) | translate
      }}
    </div>
    @if (role == Role.IssuerRep) {
      <div class="pb-3 text-justify">
        {{ 'registerIssuer.repDescription' | translate }}
      </div>
      <div class="pb-3 text-justify">
        {{ 'registerIssuer.repEmailDescription' | translate }}
      </div>
    }
    @if (role == Role.CompanyRep) {
      <div class="pb-3 text-justify">
        {{ 'signUp.repDescription' | translate }}
      </div>
      <div class="pb-3 text-justify">
        {{ 'signUp.repEmailDescription' | translate }}
      </div>
    }
    <div class="add-issuer-rep">
      @if (repFormControl.controls.length < 3) {
        <div class="btn btn-primary btn-add" (click)="addRep()">
          <i class="fa fa-plus mr-2"></i>
          {{ 'common.add' | translate }}
        </div>
      }
      <ng-container formArrayName="representatives">
        @for (rep of repFormControl.controls; track rep; let i = $index) {
          <div class="other-rep-panel" formGroupName="{{ i }}">
            <div
              class="pitchin-icon pitchin-icon-delete align-self-end"
              (click)="removeRep(i)"
            ></div>
            <div class="mb-4 mt-4">
              <div class="input-label">{{ 'signUp.identificationType' | translate }}</div>
              <div class="input-field">
                <mat-select
                  [placeholder]="'common.selectPlaceholder' | translate"
                  class="form-control"
                  formControlName="userIdentityNoType"
                  (selectionChange)="changeIdentificationType(rep)"
                >
                  @for (type of IdentificationType | enumToArray; track type) {
                    <mat-option [value]="type.key">
                      {{ 'signUp.' + type.value | translate }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div class="mb-4">
              <div class="input-label">
                {{ 'signUp.representativeNameAsPer' | translate }}
                {{ 'signUp.' + IdentificationType[rep.value.userIdentityNoType] | translate }}
              </div>
              <input
                type="text"
                class="form-control"
                placeholder="{{ 'registerIssuer.namePlaceholder' | translate }}"
                formControlName="fullName"
              />
            </div>
            <div class="mb-4">
              <div class="input-label">
                {{ 'signUp.' + IdentificationType[rep.value.userIdentityNoType] | translate }}
                {{ 'signUp.number' | translate }}
              </div>
              <div class="input-field">
                @if (rep.value.userIdentityNoType != IdentificationType.Passport) {
                  <input
                    class="form-control"
                    placeholder="{{ 'signUp.icNumberPlaceholder' | translate }}"
                    formControlName="identityNo"
                    [mask]="icMaskFormat"
                    type="text"
                  />
                }
                @if (rep.value.userIdentityNoType == IdentificationType.Passport) {
                  <input
                    class="form-control"
                    placeholder="{{ 'signUp.passportPlaceholder' | translate }}"
                    formControlName="identityNo"
                    type="text"
                    alphanumeric
                  />
                }
                @if (
                  showFormError &&
                  rep.controls.identityNo.errors &&
                  (rep.controls.identityNo.errors.pattern || rep.controls.identityNo.errors.mask)
                ) {
                  <div class="error">
                    {{ 'signUp.' + IdentificationType[rep.value.userIdentityNoType] | translate }}
                    {{ 'signUp.number' | translate }}
                    {{ 'signUp.incorrectFormat' | translate }}
                  </div>
                }
              </div>
            </div>
            <div>
              <div class="input-label">{{ 'common.email' | translate }}</div>
              <div class="input-field">
                <input
                  class="form-control"
                  placeholder="{{ 'common.emailPlaceholder' | translate }}"
                  formControlName="email"
                  type="text"
                />
              </div>
              @if (
                showFormError && rep.controls.email.errors && rep.controls.email.errors.pattern
              ) {
                <div class="error">
                  {{ 'signUp.emailFormatIncorrect' | translate }}
                </div>
              }
            </div>
          </div>
        }
      </ng-container>
    </div>
  </div>
  <div class="text-center pt-5">
    <button type="submit" class="btn btn-primary">
      {{ 'common.submit' | translate }}
    </button>
  </div>
</form>
